module.exports = __webpack_public_path__ + "img/MOBILE_Slide4.43c8567c.png";